import { render, staticRenderFns } from "./navigation-desktop.vue?vue&type=template&id=e2785f9a"
import script from "./navigation-desktop.vue?vue&type=script&lang=js"
export * from "./navigation-desktop.vue?vue&type=script&lang=js"
import style0 from "./navigation-desktop.vue?vue&type=style&index=0&id=e2785f9a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports